export const MODAL_ID = "close-lead";
